/* eslint-disable @typescript-eslint/naming-convention */
import { TrashAlt } from 'components/icons'
import { ProductQuantity, ProductImage, ProductPrice } from 'modules/products/components'
import {Dropdown, Link} from 'components/ui'
import cn from 'classnames'
import type { FC } from 'react'
import { ROUTE_PRODUCT } from 'routes/products'
import { BrowserView, MobileOnlyView } from 'react-device-detect'
import type { CartListItemProps } from '.'
import s from './cart-list-item.module.css'
import {useEffect, useState} from "react";
import {useRouter} from "next/router";

const CartItem: FC<CartListItemProps> = ({
  item,
  className = '',
  clean = false,
  canEdit = true,
  onlyView = false,
  onChangeItemQuantity,
  onChangePeriod,
  onDeleteItem,
}) => {
  // @ts-ignore
  const { id, experiencia_id, name, price, imageUrl, assinatura, period, assinatura_desconto_produtor } = item
  const router = useRouter()
  const periodList = [
    {value: 'semanal', label: 'Semanal'},
    {value: 'quinzenal', label: 'Quinzenal'},
    {value: 'mensal', label: 'Mensal'},
  ]

  const [promotionalValue, setPromotionalValue] = useState(0);

  const loadPromotionalValueSubscription = () => {
    if (assinatura_desconto_produtor !== undefined && assinatura_desconto_produtor > 0) {
      setPromotionalValue(price - (price * assinatura_desconto_produtor / 100));
    }
  }

  const changePeriod = (item: any) => {
    if (onChangePeriod) {
      onChangePeriod(id, item);
    }
  }

  useEffect(() => {
    const { slug, subscription } = router.query;
    if (slug == 'assinaturas' || subscription == 'true') {
      loadPromotionalValueSubscription()
    }
  }, [router.query]);

  return (
    <div className={cn(s.root, clean ? s.clean : s.common, className)}>
      <div className={s.productImage}>
        <ProductImage key={`product-image-${item.id}`} imageUrl={imageUrl} alt={name} width={80} height={80} />
      </div>
      <div className={s.rightContent}>
        <div className={s.productName}>
          {onlyView ? (
            <>{name}</>
          ) : (
            <Link href={`${ROUTE_PRODUCT}${item.slug}`}>{name}</Link>
          )}
          <MobileOnlyView>
            {canEdit && (
              <button className={s.removeItemFromCart} type="button" onClick={() => onDeleteItem(experiencia_id || id)}>
                <TrashAlt />
              </button>
            )}
          </MobileOnlyView>
        </div>
        <BrowserView viewClassName={s.actions}>
          <ProductPrice price={{ sell: price } as any} preco_promocional={promotionalValue} preco_promocional_ativo={promotionalValue>0} />
          {canEdit ? (
            <ProductQuantity
              canChange
              onChange={({ next }) => onChangeItemQuantity(experiencia_id || id, next)}
              quantity={item.quantity}
              dropdown={false}
            />
          ) : (
            `${item.quantity} ${item.quantity > 1 ? 'unidades' : 'unidade'}`
          )}
          {canEdit && (
            <button className={s.removeItemFromCart} type="button" onClick={() => onDeleteItem(experiencia_id || id)}>
              <TrashAlt />
            </button>
          )}
          {(assinatura === true) &&
            <div className={s.periodity}>
              Escolha a periodicidade de entrega:
              {canEdit && <Dropdown dropdownClassName={s.dropdown} selected={period} items={periodList} onSelect={changePeriod}  placeholder={'-'}/>}
              {!canEdit && <p>{period}</p>}
            </div>
          }
        </BrowserView>
        <div className={s.price}>
          <MobileOnlyView viewClassName={s.quantity}>
            <ProductPrice price={{ sell: price } as any} preco_promocional={promotionalValue} preco_promocional_ativo={promotionalValue>0} />
            {canEdit ? (
              <ProductQuantity
                canChange
                onChange={({ next }) => onChangeItemQuantity(experiencia_id || id, next)}
                quantity={item.quantity}
                dropdown={false}
              />
            ) : (
              `${item.quantity} ${item.quantity > 1 ? 'unidades' : 'unidade'}`
            )}
            {(assinatura === true) &&
              <div className={s.periodityM}>
                Escolha a periodicidade de entrega:
                {canEdit && <Dropdown dropdownClassName={s.dropdown} selected={period} items={periodList} onSelect={changePeriod}  placeholder={'-'}/>}
                {!canEdit && <p>{period}</p>}
              </div>
            }
          </MobileOnlyView>
        </div>
      </div>
    </div>
  )
}

export default CartItem
